export default function getHomeCasesData(data) {
  const mapCases = data.cases.map((caseItem, index) => {
    const scenarios = caseItem.fields.homeCaseScenarios.map((scenario, scenarioIndex) => {
      // avoid to parse cases that are empty
      if (scenario.fields) {
        // add array images to array
        const images = [];

        if (scenario.fields.smallMedia) {
          images.push(scenario.fields.smallMedia);
        }

        if (scenario.fields.largeMedia) {
          images.push(scenario.fields.largeMedia);
        }

        return {
          title: scenario.fields.scenarioTitle ? scenario.fields.scenarioTitle : false,
          description: scenario.fields.scenarioDescription ? scenario.fields.scenarioDescription : false,
          label: scenario.fields.label ? scenario.fields.label : `Scenario ${scenarioIndex + 1}`,
          images,
        };
      }
      return null;
    });

    return {
      author: {
        name: caseItem.fields.author.fields.fullName,
        jobtitle: caseItem.fields.author.fields.jobTitle,
        company: caseItem.fields?.author?.fields?.client?.fields?.name
          ? caseItem.fields.author.fields.client.fields.name
          : false,
        avatar: {
          image: caseItem.fields.author.fields.avatar.fields.file.url,
          width: caseItem.fields.author.fields.avatar.fields.file.details.image.width,
          height: caseItem.fields.author.fields.avatar.fields.file.details.image.height,
        },
      },
      index,
      tag: caseItem.fields.channelTag[0] || false,
      slug: caseItem.fields.slug,
      url: `/cases/${caseItem.fields.slug}`,
      text: {
        title: caseItem.fields.defaultScenarioTitle,
      },
      caseLinkLabel: caseItem.fields.caseLinkLabel,
      activeScenario: 0,
      scenarios,
      navigation: [
        caseItem.fields.client.fields.logoDeepPurple,
        data.campaign ? caseItem.fields.client.fields.logoWhite : caseItem.fields.client.fields.logoFrostBlue,
      ],
    };
  });

  return {
    active: 0,
    cases: mapCases,
  };
}
